import { gql } from 'graphql-request'
import { useMutation } from '@/proxy/react-query'
import type { Variables } from 'graphql-request'

import { client } from '@/proxy/client'

export const OPEN_OR_CLOSE_POC = gql`
  mutation openOrClosePoc($input: OpenOrClosePocInput!) {
    openOrClosePoc(input: $input) {
      success
      poc {
        id
        ownerName
        address {
          provinceCode
          province
          city
        }
        phoneNumbers {
          phoneNumber
          phoneType
        }
        isTimeInsideWorking
      }
      errors {
        message
      }
    }
  }
`

export interface OpenOrClosePocMutation {
  openOrClosePoc: {
    success: boolean
    poc: {
      id: string
      ownerName: string
      address: {
        provinceCode: string
        province: string
        city: string
      }
      phoneNumbers: {
        phoneNumber: string
        phoneType: string
      }
      isTimeInsideWorking: boolean
    }
    errors: string[]
  }
}

export interface OpenOrClosePocMutationVariables extends Variables {
  input: {
    operation: 'AVAILABLE' | 'CLOSED'
    reasons?: string
  }
}

export const useOpenOrClosePoc = () =>
  useMutation<OpenOrClosePocMutation, Error, OpenOrClosePocMutationVariables>({
    mutationFn: variables =>
      client.request<OpenOrClosePocMutation, OpenOrClosePocMutationVariables>(
        OPEN_OR_CLOSE_POC,
        variables
      ),
  })
